import React from "react";

const SecFooter = ({ _, logo, viewLicenseDisplay }) => (
  <div className="sec-footer">
    <p>
      {_.FooterCopyright}
      <a onClick={viewLicenseDisplay}>{_.Licenses}</a>
      <img className="sec-footer-logo float-right" src={logo} alt={_.Logo} />
    </p>
  </div>
);

export default SecFooter;
